import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ExportProjectLogsSettings, defaultExportProjectLogsSettings } from '../../../../core/models';

@Component({
  selector: 'app-export-project-logs-settings',
  templateUrl: './export-project-logs-settings.component.html',
  styleUrls: ['./export-project-logs-settings.component.scss'],
  standalone: false
})
export class ExportProjectLogsSettingsComponent implements OnInit, OnChanges {

  @Input() settings: ExportProjectLogsSettings | undefined;
  @Output() saveSettings: EventEmitter<FormGroup> = new EventEmitter<FormGroup>();

  value: ExportProjectLogsSettings = {
    ...defaultExportProjectLogsSettings
  };
  form: FormGroup = new FormGroup({
    exports_enabled: new FormControl<boolean>(false),
    sftp_host: new FormControl<string>(''),
    sftp_user: new FormControl<string>(''),
    sftp_password: new FormControl<string>(''),
    sftp_path: new FormControl<string>(''),
    providers: new FormControl<string[]>([]),
  });

  ngOnInit(): void {
    this.form.disable();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['settings']) {
      let disabled = this.form.disabled;
      this.settings = changes['settings'].currentValue;
      if (this.settings) {
        this.value = { ...defaultExportProjectLogsSettings, ...this.settings };
      }
      this.form.patchValue(this.value);
      if (disabled) {
        this.form.disable();
      }
    }
  }

  onExportsEnabledChange(): void {
    const dependentFields = ['sftp_host', 'sftp_user', 'sftp_password', 'sftp_path'];
    const validators = this.exportsEnabled ? [Validators.required] : [];
    dependentFields.forEach(field => {
      const ctrl = this.form.get(field) as FormControl;
      ctrl.setValidators(validators);
      ctrl.updateValueAndValidity();
    });
  }

  doEdit(): void {
    this.form.enable();
  }

  doCancel(): void {
    this.value = { ...defaultExportProjectLogsSettings, ...this.settings };
    this.form.reset(this.value);
    this.form.disable();
  }

  doSave(): void {
    this.form.disable();
    this.saveSettings.next(this.form);
  }

  get exportsEnabled(): boolean {
    return this.form.value.exports_enabled;
  }

}
